import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";

export function useMyDetails() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const { data, isPending, isError } = useQuery({
		queryKey: ["myDetails"],
		queryFn: () => callPymbleApi(instance, "GET", "my/details/"),
		enabled: isAuthenticated,
	});

	const hasAdminAccess = data?.active?.staff === true;
	const displayName = instance.getAllAccounts()[0]?.name ?? "";

	// Normalised view of the raw my/details response for consumers that need the
	// uploader identity (file uploads stamp UploadedBy/UploadedByDetail). The raw
	// response already carries _id/Name/Salutation; contact_id mirrors SmsId, as
	// in the portal's useMyDetails.
	const myDetails = data
		? { ...data, contact_id: data.SmsId }
		: undefined;

	return {
		isLoading: isPending,
		isError,
		hasAdminAccess,
		data,
		myDetails,
		displayName,
	};
}
